// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".F5mqGXid{display:flex;flex-direction:column;gap:max(.74rem,min(1.09vw,1.31rem));justify-content:space-between;overflow:hidden;transition:.2s ease-in-out;transition-property:transform}@media(hover:hover){.F5mqGXid:hover{transform:scale(.98)}}@media(hover:none){.F5mqGXid:active{transform:scale(.98)}}.F2rX8FWZ{aspect-ratio:387/255;border-radius:.5rem;height:auto;margin-bottom:max(.84rem,min(1.25vw,1.5rem));-o-object-fit:cover;object-fit:cover;width:100%}.\\+bAF60Jr{font-weight:600;line-height:.87;margin-bottom:.46em;word-wrap:break-word;font-size:max(1.13rem,min(1.25vw,1.5rem))}.FMvPIrBr{align-items:center;display:flex;flex-wrap:wrap;font-size:.88rem;font-weight:500;gap:.7em 1.5em;justify-content:space-between;line-height:1.43;opacity:.5}.FMvPIrBr>*{overflow:hidden;word-wrap:break-word}.OKPV-v1Q{align-items:center;display:flex;gap:max(.84rem,min(1.25vw,1.5rem));justify-content:space-between}.vIEX1lNQ{filter:grayscale(1) contrast(2);height:100%;mix-blend-mode:multiply;-o-object-fit:contain;object-fit:contain;-o-object-position:left;object-position:left;width:100%}.d8ZmtTYQ{height:max(1.48rem,min(2.19vw,2.63rem));width:max(4.54rem,min(6.72vw,8.06rem))}.ZGjj88pf{color:#32388c;font-size:.88rem;font-weight:500;line-height:1.43}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "F5mqGXid",
	"cover": "F2rX8FWZ",
	"title": "+bAF60Jr",
	"meta": "FMvPIrBr",
	"footer": "OKPV-v1Q",
	"partner": "vIEX1lNQ",
	"partnerWrapper": "d8ZmtTYQ",
	"more": "ZGjj88pf"
};
module.exports = ___CSS_LOADER_EXPORT___;
